import React, { Suspense, lazy, useContext, useEffect } from 'react';
import { Store } from '../data/Store';
import { walkDataAction, fetchDataAction, searchPedigreeFields } from '../data/Actions';

import styled from 'styled-components';

const More = styled.div`
    fontSize:12px;
    padding: 5px 0 0 calc(.5vw + 10px);
    border-top: 1px solid #bfbfbf;
    margin-bottom: 10px;
    .reset {
        color: #1890ff!important;
        cursor: pointer;
    }
    .more {
        color: black!important;
        pointer-events: none;
        cursor: not-allowed;
    }
    [view="more"] {
        &.more {
            color: #1890ff!important;
            pointer-events: auto;
            
            cursor: pointer;
        }
    }
`;

const PedigreeList = lazy(() => import('../components/PedigreeList'));
const PedigreeClientList = lazy(() => import('../components/PedigreeClientList'));

export default function SearchPage(props) {
    const { state, dispatch } = useContext(Store);
    const itemLoadLimit = 20;

    useEffect(() => {
        state.Next = null;
        state.PedType = 'USER';
        
        state.Group = props.groups[0];
        
        
        if (state.User === 'ADMIN') {
            fetchDataAction({limit: itemLoadLimit, nextToken: ''}, state, dispatch);
        } else {
            const path = {key:'Pedigree.ClientId', value: ''};
            const data = {
                path: path,
                search: [],
                limit: 20,
                next: ''
            };
            searchPedigreeFields(data, state, dispatch);
        }
        // walkDataAction(state, dispatch);
    }, []);
    
    const newProps = {
    ...props,
    pedigrees: state.PedigreeList,
    state: { state, dispatch },
    };
    
    function onMore() {
      if (state.Next.nextType === 'AS') fetchDataAction(state.Next, state, dispatch);
      if (state.Next.nextType === 'ES') searchPedigreeFields(state.Next, state, dispatch);
    }
    function onReset() {
        if (state.User === 'USER') { 
            state.Next = null;
            
            const path = {key:'Pedigree.ClientId', value: state.Group};
            const data = {
                path: path,
                search: [],
                limit: 20,
                next: ''
            };
            searchPedigreeFields(data, state, dispatch);
            
        } else {
            fetchDataAction({limit: itemLoadLimit, nextToken: ''}, state, dispatch);
        }
    }
    
    return  (
      <> { state.User === 'ADMIN' ? ( 
          <Suspense fallback={<div>Loading...</div>}>
                <PedigreeList {...newProps} />
          </Suspense>
        ) : (
          <Suspense fallback={<div>Loading...</div>}>
              <PedigreeClientList {...newProps} />
          </Suspense>
        )} { (state.PedigreeList.length > 0) ?
        (<More>
            <span className="reset" view={(state.Next && state.Next.nextToken !== '') ? 'more' : ''} onClick={onReset}>Page 1 </span> 
             | 
            <span className="more" view={(state.Next && state.Next.nextToken !== '') ? 'more' : ''} onClick={onMore}> Load More...</span>
        </More>)
        : (<More>
            <span className="reset" view={(state.Next && state.Next.nextToken !== '') ? 'more' : ''} onClick={onReset}>Page 1 </span>
        </More>)
        }
      </>
    );
}
